module.exports = __webpack_public_path__ + "static/media/flag_pt_PT.b52b7a3e.png";